export const BASE_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_REST_API_URL
    : import.meta.env.VITE_REST_API_URL_DEV;

export const CLIENT_BASE_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_CLIENT_BASE_URL
    : import.meta.env.VITE_CLIENT_BASE_URL_DEV;

export const EVENT_CLIENT_BASE_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_EVENT_CLIENT_BASE_URL
    : import.meta.env.VITE_EVENT_CLIENT_BASE_URL_DEV;

export const SOCKET_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_SOCKET_URL
    : import.meta.env.VITE_SOCKET_URL_DEV;

export const GOOGLE_SITE_KEY =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_GOOGLE_SITE_KEY
    : import.meta.env.VITE_GOOGLE_SITE_KEY_DEV;

export const BIMS_OAUTH_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? import.meta.env.VITE_BIMS_OAUTH_URL
    : import.meta.env.VITE_BIMS_OAUTH_URL;
